export default __webpack_public_path__ + "static/media/dashboard-gdi-logo.bf83074c.svg";